// src/pages/History/20thCentury/WorldWarII.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_World_War_II.png';

function HistoryPageWorldWarII() {
  return (
    <TopicPage
      topicKey="World War II"
      title="History: World War II"
      backgroundImage={bg}
      startRoute="/History-World-War-II-Go"
      scrollLabels={[
        "Rise of Totalitarianism",
        "Major Battles and Turning Points",
        "Aftermath and United Nations",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageWorldWarII;
